import createTypes from 'redux-create-action-types';

export default createTypes(
  'CREATE_CUSTOM_FIELD',
  'UPDATE_CUSTOM_FIELD',
  'DELETE_CUSTOM_FIELD'
);
